import React from 'react';
import Header from './Header';
import Hero from './Hero';
import Filters from './Filters';
import CleItem from './CleItem';

export default function Cle({
  currentUser, cleItems, isAdmin, tags, topics, academySubscription, subscription, userSession, totalCredits,
}) {
  const cleLanguage = (
    <p style={{ textAlign: 'center', width: '80%', margin: '0 auto' }}>
      {currentUser.first_name || 'Friend'}
      , this page tracks the content you have viewed for CLE credit. The courses you have watched are listed below
      with the credits available for each. Where a course is listed with a percentage vs. completed, that indicates
      that course is in progress but must be completed before credit can be awarded. Your jurisdiction is listed
      according to your settings. To update your jurisdiction, click
      {' '}
      <a href="/account/edit?tab=cle" style={{ color: 'black', textDecoration: 'underline' }}>here</a>
      .
    </p>
  );

  return (
    <div className="react-lc-page lc-bookmarks">
      <Header currentUser={currentUser} isAdmin={isAdmin} academySubscription={academySubscription} userSession={userSession} />
      <Hero
        title="MyCLE"
        subtitle="Track and manage your CLE for submission to your jurisdiction"
      >
        <Filters tags={tags} topics={topics} personalisedSearch="cle" />
      </Hero>
      <div className="section">
        { cleItems && cleItems.length > 0 ? (
          <>
            {cleLanguage}
            <div className="table-items" style={{ marginTop: '3.5rem' }}>
              <div className="row" key="header">
                <div style={{ textAlign: 'center' }}>Title</div>
                <div className="cle-data">Credits</div>
                <div className="cle-data">Content Length</div>
                <div className="cle-data">Approved jurisdictions</div>
                <div className="cle-data">Progress</div>
              </div>
              {cleItems?.map((item) => (
                <CleItem
                  item={item}
                  breadcrumb="cle"
                  isAdmin={isAdmin}
                  academySubscription={academySubscription}
                  subscription={subscription}
                />
              ))}
              <hr />
            </div>
            <p style={{ marginTop: '0', textAlign: 'right' }}>
              Total Credits awarded to date:
              {' '}
              {totalCredits}
            </p>
            <p style={{ marginTop: '1.5rem', textAlign: 'center' }}>
              If your course is not approved for CLE in your jurisdiction, you will need to self-report in order to
              receive
              credit.
            </p>
          </>
        ) : (
          <p style={{ textAlign: 'center', width: '60%', margin: '1.5rem auto' }}>
            You have not yet viewed content that is approved for CLE. To find content approved for CLE, go to the
            Approved CLE Module, or find content that includes the icon in the upper right corner.
            Please be sure to have your CLE jurisdiction added in your
            {' '}
            <a href="/account/edit?tab=cle" style={{ color: 'black', textDecoration: 'underline' }}>settings</a>
            .
            Once you begin viewing CLE content, it will populate on this page.
          </p>
        )}
      </div>
    </div>
  );
}
